"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AssistantStandalone;
var _react = _interopRequireWildcard(require("react"));
var _AssistantProvider = require("./AssistantProvider");
var _constants = require("./constants");
var _ThreadHeader = _interopRequireDefault(require("./ThreadHeader"));
var _ThreadView = _interopRequireDefault(require("./ThreadView"));
var _ThreadHistory = _interopRequireDefault(require("./ThreadHistory"));
var _FeedbackModal = _interopRequireDefault(require("./FeedbackModal"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function AssistantStandalone() {
  const {
    threads,
    activeThreadId,
    switchThread,
    importThread,
    startNewThread,
    deleteThread,
    resetPath
  } = (0, _AssistantProvider.useAssistant)();
  const handleNew = () => {
    resetPath();
    startNewThread();
  };
  (0, _react.useEffect)(() => {
    try {
      localStorage.setItem('sa_sidebar_width', String(_constants.SIDEBAR.DEFAULT_WIDTH));
    } catch (_unused) {}
  }, []);
  return (0, _jsxRuntime.jsxs)("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      overflow: 'hidden',
      fontFamily: '"Inter", "Segoe UI", system-ui, -apple-system, sans-serif',
      fontSize: '15px',
      color: '#1a1a2e',
      lineHeight: 1.6,
      background: 'linear-gradient(145deg, #f8f9fc 0%, #eef1f8 50%, #f0f4ff 100%)',
      letterSpacing: '-0.01em'
    },
    children: [(0, _jsxRuntime.jsx)(_ThreadHeader.default, {
      mode: "standalone"
    }), (0, _jsxRuntime.jsxs)("div", {
      style: {
        flex: 1,
        display: 'flex',
        minHeight: 0
      },
      children: [(0, _jsxRuntime.jsx)(_ThreadHistory.default, {
        threads: threads,
        activeThreadId: activeThreadId,
        onSelect: switchThread,
        onImportThread: importThread,
        onNew: handleNew,
        onDelete: deleteThread
      }), (0, _jsxRuntime.jsx)("div", {
        style: {
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0
        },
        children: (0, _jsxRuntime.jsx)(_ThreadView.default, {
          mode: "standalone"
        })
      })]
    }), (0, _jsxRuntime.jsx)(_FeedbackModal.default, {})]
  });
}